<template>
    <div class='myHeader'>
        <div class="left">
            <img :src="require('@/assets/images/logo.png')" alt="">
            <span>炎黄族谱管理平台</span>
        </div>
        <div class="right" v-if='userInfo.userName'>
            <i class="el-icon-user-solid"></i>
            <span> {{ userInfo.userName }} </span>
            <ul class="head-ul">
                <li @click="setpwd" class="head-ul-li">修改密码</li>
                <li @click="loginOut" class="head-ul-li">退出登录</li>
            </ul>
        </div>
        <el-dialog title="修改密码" :visible.sync="centerDialogVisible" width="30%" center>
            <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                <el-form-item label="原密码" prop="oldPassword">
                    <el-input v-model="form.oldPassword" type="password" autocomplete="off" />
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input v-model="form.newPassword" type="password" autocomplete="off" />
                </el-form-item>
                <el-form-item label="确认新密码" prop="confirmPassword">
                    <el-input v-model="form.confirmPassword" type="password" autocomplete="off" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="servePwd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Cookies from 'js-cookie';
import { updatePassword } from '@/api/pc';
export default {
    name: 'myHeader',
    data() {
        const validateConfirm = (rule, value, callback) => {
            if (value !== this.form.newPassword) {
                callback(new Error('两次输入的新密码不一致'));
            } else {
                callback();
            }
        };
        return {
            centerDialogVisible: false,
            form: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            rules: {
                oldPassword: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请确认新密码', trigger: 'blur' },
                    { validator: validateConfirm, trigger: 'blur' }
                ]
            }
        }
    },
    props: {
        userInfo: {
            type: Object,
            default: () => { return { userName: '' } }
        }
    },
    methods: {
        loginOut() {
            Cookies && Cookies.remove('zuji-token');
            Cookies && Cookies.remove('zujiUserInfo');
            this.$router.push({ path: '/login' })
        },
        setpwd() {
            this.centerDialogVisible = true;
            this.$refs.form.resetFields();
        },
        servePwd() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    // 这里调用API修改密码
                    let params= {password: this.form.newPassword}
                    updatePassword(params).then(res => {
                        if(res.code==200){
                            this.$message.success('密码修改成功');
                            this.loginOut();
                        }
                    })
                }
            });
        }
    }
}
</script>
<style lang='scss' scoped>
.myHeader {
    width: 100%;
    height: 60px;
    background-color: #afc9e6;
    overflow: hidden;
    box-sizing: border-box;
    padding: 10px 20px;
    border-bottom: 1px solid #ebebeb99;

    .left {
        float: left;
        height: 100%;
        font-size: 0;

        img {
            width: 40px;
            height: 40px;
            display: inline-block;
            vertical-align: middle;
        }

        span {
            display: inline-block;
            vertical-align: middle;
            font-size: 24px;
            color: #333;
            margin-left: 10px;
        }
    }

    .right {
        float: right;
        font-size: 0;
        height: 40px;
        padding: 10px 0;
        cursor: pointer;

        i {
            display: inline-block;
            vertical-align: top;
            font-size: 16px;
            color: #1890ff;
            background-color: #ffffff99;
            width: 20px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 50%;
        }

        span {
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            color: #fff;
            margin-left: 10px;
            height: 20px;
            line-height: 20px;
        }

        &:hover .head-ul {
            display: block;
        }

        .head-ul {
            display: none;
            width: 120px;
            position: absolute;
            right: 0;
            top: 40px;
            padding-top: 20px;
            padding-bottom: 10px;
            background-color: #1f2d3d;
            z-index: 2;

            .head-ul-li {
                width: 100%;
                height: 40px;
                line-height: 40px;
                color: #fff;
                font-size: 14px;
                text-align: center;

                &:hover {
                    background-color: #ddd;
                    color: #1890ff;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>